import { EventType, EventTypeDetailed } from "@/types";

import { axios } from "../axios.instance";

export type GetMyEventsRequest = {
  perPage?: number;
  cursor?: string;
};

export type GetMyEventsResponse = {
  data: Array<EventType & EventTypeDetailed>;
  meta: {
    hasNextPage: boolean;
    nextCursor?: string;
  };
};

export const getMyEvents = async (params: GetMyEventsRequest): Promise<GetMyEventsResponse> => {
  const { data } = await axios.get(`/events/my`, { params });

  return data;
};
